export interface MyCoursesEntry {
  id: string;
  courseName: string;

  gradeName: string;
  classNames: string[];
  nextOccurrenceStart: string;
  nextOccurenceEnd: string;
  color?: string;
  quantityNotifications?: number;
}

export enum MyCoursesColumns {
  CourseName = 1 << 0,
  ClassGrade = 1 << 1,
  NextOccurrence = 1 << 2,
}

export interface MyCoursesProps {
  courses: MyCoursesEntry[];
  onCourseClick: (course: MyCoursesEntry) => void;
  columns: MyCoursesColumns;
  showHeader: Boolean;
}
